
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/expo",
      function () {
        return require("private-next-pages/blogs/expo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/expo"])
      });
    }
  